import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function ThankYou() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <SEO title="Thank You | Mathura Homes" description="Thank you for your enquiry." />
      <div className="text-center max-w-lg" data-testid="thank-you-page">
        <CheckCircle2 className="w-20 h-20 text-emerald-brand mx-auto mb-6" />
        <h1 className="font-display text-4xl text-navy">Thank You!</h1>
        <p className="text-muted-foreground mt-4 leading-relaxed">Your enquiry has been received successfully. One of our property advisors will contact you shortly to assist with your requirements.</p>
        <div className="flex flex-wrap justify-center gap-4 mt-8">
          <Button asChild className="bg-gold text-navy hover:bg-gold-dark font-semibold"><Link to="/properties">Explore Properties</Link></Button>
          <Button asChild variant="outline" className="border-navy text-navy hover:bg-navy hover:text-white"><Link to="/">Back to Home</Link></Button>
        </div>
      </div>
    </div>
  );
}
